<div class="list-contain grid" *ngIf="show">
    <div class="item_container grid">
        <ng-container *ngFor="let item of items; index as i">
            <ng-container>
                <app-card class="list_parent_item-new grid" [item]="item" viewType="grid"></app-card>
            </ng-container>
            <ng-container *ngIf="bannerPosition[i] && banner?.id">
                <app-banner class="list_parent_item-new grid" [banner]="banner" viewType="grid"></app-banner>
            </ng-container>
        </ng-container>
    </div>
</div>
